import React from 'react';
import Link from '../common/TrackedLink';

class Card extends React.Component {
	constructor(props) {
		super(props);
		this.state = ({
			checked: false
		});
	}

	addToCompare(event) {
		const { product } = this.props;
		this.props.addToCompare(event);
		if (this.state.checked === true) {
			this.setState({ checked: false });
		} else {
			this.setState({ checked: true });
		}
		global.dataLayer.push({
			event: 'Product Tile',
			eventCategory: 'Product Tile',
			eventAction: 'Compare - Product Selector',
			eventLabel: `${product.name} - Model ${product.modelNumber}`
		});
	}

	handleClickCompare() {
		this.props.clickCompare();
	}

	render() {
		const { modelNumber, name, image, priceBucket } = this.props.product;
		return (
			<div className="product-card">
				<Link
					className="product-info"
					to={ `/product/${modelNumber}` }
					trackEvent="Product Tile"
					trackEventCategory="Product Tile"
					trackEventAction="Product Selector"
					trackEventLabel={ `${name} - Model ${modelNumber}` }
				>
					<figure>
						<img
							src={ image }
							alt=""
						/>
					</figure>
					<h3>{ name }</h3>
					<p>
						Model { modelNumber }<br />
						{ priceBucket }
					</p>
					<span className="arrow-link">
						View details
					</span>
				</Link>
				{
					this.props.canCompare ?
						<div className="compare">
							<input
								type="checkbox"
								id={ `compare${modelNumber}` }
								value={ modelNumber }
								checked={ this.props.product.checked }
								onChange={ () => this.addToCompare(modelNumber) }
							/>
							<label
								htmlFor={ `compare${modelNumber}` }
								className={ this.state.checked ? 'assistive-text' : 'active' }
							>
								Check to Compare
							</label>
							<a
								onClick={ () => this.handleClickCompare() }
								className={ this.state.checked ? 'active' : 'hide' }
							>
								Compare
							</a>
						</div> : ''
				}
			</div>
		);
	}
};

export default Card;


// WEBPACK FOOTER //
// ./src/pages/safeSelector/Card.js